import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "d-flex mobile-column" }
const _hoisted_3 = { class: "left pe-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "fw-9" }, "OneRepublic", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = { class: "col-md-8 mx-auto" }
const _hoisted_9 = { class: "row codeHolder" }
const _hoisted_10 = { class: "col-3 p-3" }
const _hoisted_11 = { class: "col-3 p-3" }
const _hoisted_12 = { class: "col-3 p-3" }
const _hoisted_13 = { class: "col-3 p-3" }
const _hoisted_14 = { class: "text-center mt-5" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card border-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/img.jpeg",
      class: "img-fluid card-img-top",
      alt: ""
    })
  ])
], -1)

import { useRoute, useRouter } from "vue-router";
import { computed, ref, Ref } from "vue";
import axios, { AxiosError } from "axios";
import { apiHost } from "@/data/constants";
import { useForm } from "vee-validate";
import * as Yup from "yup";


export default /*#__PURE__*/_defineComponent({
  __name: 'Page2',
  setup(__props) {

const codeInput1: Ref<HTMLInputElement | undefined> = ref()
const codeInput2: Ref<HTMLInputElement | undefined> = ref()
const codeInput3: Ref<HTMLInputElement | undefined> = ref()
const codeInput4: Ref<HTMLInputElement | undefined> = ref()

const inputs = {
  '1': codeInput1,
  '2': codeInput2,
  '3': codeInput3,
  '4': codeInput4,
} as { [k: string]: Ref<HTMLInputElement> }

const router = useRouter();
const route = useRoute();

const handlekeydown = (event: KeyboardEvent) => {
  if (!isNaN(parseInt(event.key))) {
    return
  } else if (event.key == "Meta" || event.metaKey || event.ctrlKey) {

  } else {
    event.preventDefault();
    event.stopPropagation();
  }
}

const handlekeyup = (event: KeyboardEvent, inputNumber: number) => {
  if (event.code === 'Backspace') {
    inputNumber -= 1;
  } else if (!isNaN(parseInt(event.key))) {
    inputNumber += 1;
  } else {
    return;
  }
  console.log({event})

  if (inputs[inputNumber.toString()]) {
    inputs[inputNumber.toString()].value.focus();
  }
}

const code1 = ref('')
const code2 = ref('')
const code3 = ref('')
const code4 = ref('')

const codeEntered = computed(() => {
  console.log((code1.value + code2.value + code3.value + code4.value))
  return (code1.value + code2.value + code3.value + code4.value).length === 4;
})
const submitButtonDisabled = ref(false)
const onFormSubmit = async () => {
  try {
    submitButtonDisabled.value = true;

    const code = code1.value + code2.value + code3.value + code4.value;

    const data = {
      email: route.query.email,
      code: code,
    }

    const response = await axios.post(`${apiHost}/myvideo/check_email_verification_code`, data)
    // await router.push({name: "page2", query: data})
    await router.push({name: "page3", query: data})
  } catch (e) {
    const axiosError = e as AxiosError;
    if (axiosError.response?.status === 404) {
      alert('The code is invalid or was already used')
    } else {
      alert('Error')
    }
  } finally {
    submitButtonDisabled.value = false;
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("h5", _hoisted_6, " Please enter the 4 digit code we just sent to " + _toDisplayString(_unref(route).query.email), 1),
        _createElementVNode("form", {
          onSubmit: _withModifiers(onFormSubmit, ["prevent"]),
          action: ""
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((code1).value = $event)),
                  onKeydown: handlekeydown,
                  onKeyup: _cache[1] || (_cache[1] = ($event: any) => (handlekeyup($event, 1))),
                  ref_key: "codeInput1",
                  ref: codeInput1,
                  type: "text",
                  class: "form-control border-dark rounded-0",
                  name: "",
                  id: "",
                  maxlength: "1"
                }, null, 544), [
                  [_vModelText, code1.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((code2).value = $event)),
                  onKeydown: handlekeydown,
                  onKeyup: _cache[3] || (_cache[3] = ($event: any) => (handlekeyup($event, 2))),
                  ref_key: "codeInput2",
                  ref: codeInput2,
                  type: "text",
                  class: "form-control border-dark rounded-0",
                  name: "",
                  id: "",
                  maxlength: "1"
                }, null, 544), [
                  [_vModelText, code2.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((code3).value = $event)),
                  onKeydown: handlekeydown,
                  onKeyup: _cache[5] || (_cache[5] = ($event: any) => (handlekeyup($event, 3))),
                  ref_key: "codeInput3",
                  ref: codeInput3,
                  type: "text",
                  class: "form-control border-dark rounded-0",
                  name: "",
                  id: "",
                  maxlength: "1"
                }, null, 544), [
                  [_vModelText, code3.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((code4).value = $event)),
                  onKeydown: handlekeydown,
                  ref_key: "codeInput4",
                  ref: codeInput4,
                  type: "text",
                  class: "form-control border-dark rounded-0",
                  name: "",
                  id: "",
                  maxlength: "1"
                }, null, 544), [
                  [_vModelText, code4.value]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              disabled: !_unref(codeEntered) || submitButtonDisabled.value,
              class: "btn btn-dark py-2 px-5 rounded-0"
            }, _toDisplayString(submitButtonDisabled.value ? "Please wait..." : "Confirm"), 9, _hoisted_15)
          ])
        ], 40, _hoisted_7)
      ]),
      _hoisted_16
    ])
  ]))
}
}

})